import React from 'react'
import { Condition, ScoutFulfillment } from 'types/common'
import { FiCheck } from 'react-icons/fi'
import { SmallText, BaseText } from 'components/common/text'
import { Column, Row } from 'components/common/layout'
import { theme } from 'infra/theme'
import { DescBox } from 'components/scouts/chat/styles'
import { Badge, BadgeColor } from 'components/common/badge'

export const ConditionSatisfaction: React.FC<{
  importantConditions: Condition[]
  normalConditions: Condition[]
  fulfillments: ScoutFulfillment[]
}> = ({ importantConditions, normalConditions, fulfillments }) => {
  return (
    <>
      <Column style={{ gap: 8 }}>
        <Badge
          color={BadgeColor.SECONDARY}
          filled
          style={{ width: 'fit-content' }}
        >
          중요
        </Badge>
        <ConditionList
          conditions={importantConditions}
          fulfillments={fulfillments}
        />
      </Column>
      <Column style={{ gap: 8 }}>
        <Badge
          color={BadgeColor.SECONDARY}
          filled
          style={{ width: 'fit-content' }}
        >
          선호
        </Badge>
        <ConditionList
          conditions={normalConditions}
          fulfillments={fulfillments}
        />
      </Column>
    </>
  )
}

const ConditionList: React.FC<{
  conditions: Condition[]
  fulfillments: ScoutFulfillment[]
}> = ({ conditions, fulfillments }) => {
  return (
    <>
      {conditions.map((condition) => {
        const isRequired = fulfillments
          .map((item) => item.dataKey)
          .includes(condition.dataKey)
        const description = fulfillments.find(
          (item) => item.dataKey === condition.dataKey,
        )?.description
        return (
          <Column key={condition.dataKey} style={{ gap: 4 }}>
            <Row style={{ gap: 10, alignItems: 'center' }}>
              <FiCheck
                size={24}
                color={isRequired ? theme.color.primary : theme.color.gray3}
                strokeWidth={3}
              />
              <BaseText style={{ flex: 1 }}>{condition.value}</BaseText>
            </Row>
            {description && (
              <DescBox
                style={{
                  padding: '4px 8px',
                  marginLeft: 30,
                  backgroundColor: '#eeeeee',
                }}
              >
                <SmallText style={{ color: '#999999' }}>
                  {description}
                </SmallText>
              </DescBox>
            )}
          </Column>
        )
      })}
    </>
  )
}
